import { render, staticRenderFns } from "./vov-widget.vue?vue&type=template&id=3da60d38&"
import script from "./vov-widget.vue?vue&type=script&lang=ts&"
export * from "./vov-widget.vue?vue&type=script&lang=ts&"
import style0 from "./vov-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports